export enum StateEnum {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  STOPPED = 'STOPPED',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum QueryDossiersOrderByColumn {
  ID = 'ID',
  CREATED_AT = 'CREATED_AT',
}

export enum FinancingType {
  BTL = 'btl',
  P2P = 'p2p',
}

export enum ArchiveReasonsEnum {
  NO_RESPONSE = 'NO_RESPONSE',
  NO_DEAL_APPRAISAL = 'NO_DEAL_APPRAISAL',
  NO_DEAL_PROVISION = 'NO_DEAL_PROVISION',
  NO_DEAL_INTEREST = 'NO_DEAL_INTEREST',
  NO_DEAL_UBO = 'NO_DEAL_UBO',
  NO_DEAL_LEAD_TIME = 'NO_DEAL_LEAD_TIME',
  OTHER = 'OTHER',
}

export enum VoteEnum {
  YES = 'YES',
  NO = 'NO',
}

export enum AdvisorStatusEnum {
  PREPARED = 'preparing_appointment',
  READY_MEETING = 'ready_meeting',
  PREPARING_IM = 'preparing_im',
  SCHEDULING_APPOINTMENT_PREPARE = 'scheduling_appointment_prepare',
  WAITING_ON_SIGNED_QUOTE_GREENLIGHT = 'waiting_on_signed_quote_greenlight',
  BRIEFING_NOTARY = 'briefing_notary',
  INFORM_NOTARY = 'inform_notary',
  BRIEFING_NOTARY_WAITING = 'briefing_notary_waiting',
  VERIFY_NOTARY = 'verify_notary',
  GOING_TO_PASS = 'going_to_pass',
  WAITING_FOR_DEED = 'waiting_for_deed',
  WAITING_ON_SIGNED_ACCEPTANCE = 'waiting_on_signed_acceptance',
  WAITING_ON_SIGNED_ACCEPTANCE_SIGN = 'waiting_on_signed_acceptance_sign',
  IS_OFFER = 'is_offer',
  REALIZED = 'realized',
  STOPPED = 'stopped',
}
